<template>
    <div>
        <!-- style="transform: scale(0.78); width: 112%; margin-left: -10%;" -->
        <page-title heading="Laporan Stok Obat & BHP"
            :breadcrumb="[
              {
                label: 'Manajemen Stok',
                link: '/klinik/stok'
              },
              {
                label: 'Laporan Stok',
                active: true
              }
            ]"
            class="layout-gantung ninja-shadow" />

        <div class="container-fluid __zoom_display">
            <div class="card card-box ninja-shadow">
                <div class="card-body">
                    <b-row class="head-filter">
                        <b-col cols="4">
                            <b-row class="align-items-center">
                                <b-col cols="3">
                                    <label class="lb-header-filter">Tanggal</label>
                                </b-col>
                                <b-col cols="7">
                                    <date-picker v-model="from"
                                        type="date"
                                        range
                                        format="DD-MM-YYYY"
                                        value-type="YYYY-MM-DD"
                                        placeholder="DD-MM-YYYY"
                                        :style="'width: 100%'"
                                        @input="searchValueChanged($event, 'from')"
                                        id="dt-picker-report-stock-obat">
                                    </date-picker>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-button variant="danger"
                            class="align-self-end mt-3 mr-3"
                            @click="downloadStockReport">
                            <font-awesome-icon icon="download" />
                            Download Data
                        </b-button>
                    </b-row>
                    <div class="stright-line"></div>
                    <b-col md="12">
                        <DataTableWrapper :perPage="perPage"
                            :customEntryOptions="{f: [5]}"
                            :fromPage="fromPage"
                            :toPage="toPage"
                            :totalEntries="totalEntries"
                            :currentPage="currentPage"
                            :callbackFunc="fetchListLaporanStock"
                            @valueChanged="handleValueChanged">

                            <b-table :items="laporanStockList"
                                :fields="fieldList"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                thead-tr-class="izd-datatable"
                                :no-local-sorting="true">

                                <template v-slot:head(category)="data">
                                    {{ data.label }}

                                    <template>
                                        <vue-select-clearable id="categoryOpt"
                                            style="font-weight: normal; font-size: 13px;"
                                            :options="categoryOpt"
                                            v-model="categoryId"
                                            @input="searchValueChanged($event, 'category_id')"
                                            class="mt-2"
                                            placeholder="Kategori">
                                            <template slot="option"
                                                slot-scope="option">
                                                {{ option.label }}
                                            </template>
                                            <template slot="selected-option"
                                                slot-scope="option">
                                                {{ option.label }}
                                            </template>
                                        </vue-select-clearable>
                                    </template>
                                </template>

                                <template v-slot:head(name)="data">
                                    {{ data.label }}
                                    <b-input size="sm"
                                        class="mt-2 w-95"
                                        v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)" />
                                </template>

                                <template v-slot:head(satuan)="data">
                                    {{ data.label }}
                                    <b-input size="sm"
                                        class="mt-2 w-95"
                                        v-if="data.field.searchable"
                                        @input="searchValueChanged($event, data.field.key)" />
                                </template>

                                <template v-slot:cell(actions)="data">
                                    <span>
                                        <b-button size="sm"
                                            variant="primary"
                                            @click="detailReportStock(data.item)">
                                            <font-awesome-icon icon="search" />
                                        </b-button>
                                    </span>
                                </template>

                            </b-table>
                        </DataTableWrapper>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import debounce from "lodash/debounce";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
moment.locale("id");

import {
    faCopy,
    faDownload,
    faSearch
} from "@fortawesome/free-solid-svg-icons";

library.add(faCopy, faDownload, faSearch);

export default {
    components: {
        DataTableWrapper: () => import("../../components/DataTableWrapper"),
        DatePicker,
        "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
    },
    data() {
        return {
            firstLoadStock: true,
            firstStockAdded: '',
            categoryId: '',
            categoryOpt: [],

            user_type: null,
            user_name: "",
            from: [moment(this.firstStockAdded).format('YYYY-MM-DD'), moment().format("YYYY-MM-DD")],
            to: null,

            perPage: 10,
            currentPage: 1,
            rows: 0,
            fromPage: 0,
            toPage: 0,
            totalEntries: 0,
            sortBy: "",
            sortDesc: false,
            searchValue: [],
            laporanStockList: []
        };
    },
    computed: {
        ...mapGetters(["getKlinikId", "klinikUser"]),
        klinik() {
            let klinikCurr = this.$store.state.klinikUser.filter((item) => {
                return (item.pivot.klinik_id === this.$store.state.klinikId)
            });

            return klinikCurr[0];
        },
        fieldList() {
            const {
                generateFieldList: g,
                setSearchableAndSortableFieldList: s
            } = this;
            const r = val => Boolean(/(no|actions|viewed)\b/gi.test(val) ? !1 : 1);
            return (
                [
                    {
                        key: "category",
                        label: "Kategori",
                    },
                    {
                        key: "name",
                        label: "Nama Obat & BHP"
                    },
                    {
                        key: "stock_in",
                        label: "Total Stok Masuk",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "used_stock",
                        label: "Penggunaan Obat/BHP",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "remaining_stock",
                        label: "Sisa Stok",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "satuan",
                        label: "Satuan",
                        thClass: "text-center",
                        tdClass: "text-left"
                    },
                    {
                        key: "actions",
                        thStyle: "width: 120px"
                    }
                ]
                |> (v => s({ field: v, customFunc: r }))
                |> (z => g({ field: z }))
            );
        }
    },
    mounted() {
        this.getFirstStockAdded();
        this.getCategory();
    },

    watch: {
        currentPage(val) {
            this.fetchListLaporanStock();
        },
        perPage() {
            this.fetchListLaporanStock();
        },
        sortBy() {
            this.fetchListLaporanStock();
        },
        sortDesc() {
            this.fetchListLaporanStock();
        },
        searchValue: {
            handler: function (val) {
                if (!this.firstLoadStock) this.fetchListLaporanStock();
            },
            deep: true
        }
    },
    methods: {
        getTodayDate() {
            return [moment(this.firstStockAdded).format('YYYY-MM-DD'), moment().format("YYYY-MM-DD")];
        },
        getSampleData() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({
                        status: true,
                        data: {
                            total: 10,
                            from: 1,
                            to: 10,
                            data: [
                                {
                                    "id": 1,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 2,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 3,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 4,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 5,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 6,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 7,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                                {
                                    "id": 8,
                                    "category": "Anindita",
                                    "name": "Elastic Bandage 7,5CM x 4,5M",
                                    "used_stock": 23,
                                    "stock_in": 24,
                                    "remaining_stock": 25
                                },
                            ]
                        }
                    });
                }, 500);
            });
        },
        async getFirstStockAdded() {
            const response = await axios.get(`${this.url_api}/klinik/stock/first-stock-added?klinik_id=${this.getKlinikId}`);
            this.firstStockAdded = response.data.data;
        },
        async getCategory() {
            const response = await axios.get(`${this.url_api}/klinik/list-kategori`)
            this.categoryOpt = response.data.data
                .filter(item => item.nama == "Obat" || item.nama == "Bahan Habis Pakai")
                .map(item => ({
                    label: item.nama,
                    value: item.id
                }));
        },
        async fetchListLaporanStock() {
            if (this.firstLoadStock) {
                await this.getFirstStockAdded();
                this.from = this.getTodayDate();
                this.searchValue = [
                    {
                        key: "from",
                        value: this.from
                    }
                ];
            }

            // let response = await this.getSampleData();
            let response = await axios.get(
                `${this.url_api}/klinik/stock/report?klinik_id=${this.getKlinikId
                }&limit=${this.perPage}&page=${this.currentPage
                }${this.determineParameter()}`
            );
            this.firstLoadStock = false;
            const { status, data } = response.data;

            if (status) {
                const {
                    data: laporanStockList,
                    total: totalEntries,
                    to: toPage,
                    from: fromPage
                } = data; //data.data

                this.laporanStockList = laporanStockList;
                this.rows = totalEntries || 0;
                this.toPage = toPage || 0;
                this.fromPage = fromPage || 0;
                this.totalEntries = totalEntries;

                return this;
            }
        },
        // SETTING TABLE
        handleValueChanged({ perPage, currentPage }) {
            perPage && (perPage |> (_ => (this.perPage = _)));
            currentPage && (currentPage |> (_ => (this.currentPage = _)));
        },
        searchValueChanged: debounce(function (val, key) {
            if (key == "from" && val[0] == null && val[1] == null) {
                val = this.from = this.getTodayDate()
            }

            if (key == 'category_id') {
                val = (val == null || val == undefined) ? '' : val.value
            }
            const { searchValue } = this;

            const z = searchValue.filter(item => item.key !== key);

            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];

        }, 500),
        async detailReportStock({ id } = {}) {
            if (id) {
                this.$router.push({
                    name: "klinik-stock-report-detail",
                    params: {
                        id: id
                    },
                    query: { 
                        from: this.from[0],
                        to: this.from[1]
                    }
                });
            }
        },
        determineParameter() {
            const { searchValue, sortBy, sortDesc } = this;
            let v = "";

            searchValue.map(item => {
                const x = item.key;
                if (item.key == "from") {
                    v += `&from=${item.value[0] || ""}`;
                    v += `&to=${item.value[1] || ""}`;
                } else {
                    v += `&${x}=${item.value || ""}`;
                }
            });

            if (sortBy) {
                v += `&column=${sortBy}&order=${sortDesc ? "desc" : "asc"}`;
            }

            return v;
        },
        async downloadStockReport() {
            const res = await axios.get(
                `${this.url_api}/klinik/stock/report/export?klinik_id=${this.getKlinikId
                }${this.determineParameter()}`
            );

            const { status, data } = res.data;

            if (status) {
                let link = document.createElement("a");
                link.href = data.link;
                link.setAttribute("download", data.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.selectedId = [];
            } else {
                this.$swal({
                    text: "Something went wrong",
                    type: "error"
                });
            }
        },
    }
};
</script>
  
<style scoped lang="css">
.bg-kuning {
    background: #f7fc6b;
}

.bg-kuning,
.bg-danger,
.bg-first {
    color: black !important;
}

.no-padding {
    padding: 0 !important;
}

.page-item.active a {
    background: #3b86ff;
    border: none !important;
}

.ninja-shadow {
    box-shadow: 0px 8px 15px 0px lightgrey;
}

.head-filter {
    margin: 20px 0;
    justify-content: space-between;
}

.lb-header-filter {
    color: #217fc3;
    font-weight: 600;
}

.__zoom_display {
    /* transform: scale(0.8);
  width: 132%;
  margin-left: -16%;
  margin-top: -130px !important; */
    zoom: 80%;
    margin-top: -150px !important;
}

.download-data {
    margin-bottom: 100px;
}
</style>
    
<style lang="css">
.tooltip {
    display: block !important;
    z-index: 10000;
}

.tooltip .tooltip-inner {
    background: rgb(18, 106, 207);
    color: white;
    border-radius: 5px;
    padding: 5px 10px 4px;
    box-shadow: 0px 0px 0px rgba(black, .1) !important;
}

.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: rgb(18, 106, 207);
    z-index: 1;
}

#dt-picker-report-stock-obat .mx-input {
    height: 41.7px !important;
}

#categoryOpt .vs__dropdown-toggle {
    height: calc(1.5em + 0.5rem + 2px) !important;
    background-color: #ffffff;
}
</style>
  